import { useReactiveVar } from '@apollo/client'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import {
  CheckoutRoute,
  useCheckoutRouter,
} from '@src/hooks/useCheckoutRouter/useCheckoutRouter'
import { jwtVar } from '@src/models/customer/jwt'

import { DrawerHeader, DrawerHeaderActions } from '../Drawer/DrawerHeader'

export const CheckoutHeader: React.FC<{
  addOnItemsHeader: string
}> = ({ addOnItemsHeader }) => {
  const { t } = useTranslation('checkout')
  const { defaultedRoute, displayPermanentCheckout } = useCheckoutRouter()

  const isAuthenticated = useReactiveVar(jwtVar) !== null

  const headerTitle = useMemo(() => {
    switch (defaultedRoute) {
      case CheckoutRoute.BASKET:
        return t('basket')
      case CheckoutRoute.FULFILMENT:
        return t('checkout')
      case CheckoutRoute.PAYMENT:
        return t('payment')
      case CheckoutRoute.OFFERS:
        return addOnItemsHeader
      case CheckoutRoute.PAYMENT_REDIRECT_VERIFICATION:
        return t('payment')
      case CheckoutRoute.COMPLETE:
        return t('your_order')
    }
  }, [defaultedRoute, t, addOnItemsHeader])

  const action = useMemo(() => {
    if (defaultedRoute === CheckoutRoute.BASKET) {
      // wide desktop basket has no back button, everywhere else is close
      return displayPermanentCheckout ? undefined : DrawerHeaderActions.CLOSE
    }

    // complete has a close button, everywhere else is back
    return defaultedRoute === CheckoutRoute.COMPLETE
      ? DrawerHeaderActions.CLOSE
      : DrawerHeaderActions.BACK
  }, [defaultedRoute, displayPermanentCheckout])

  // unauthenticated fulfilment step has it's own header
  if (defaultedRoute === CheckoutRoute.FULFILMENT && !isAuthenticated) {
    return null
  }

  return <DrawerHeader headerText={headerTitle} action={action} isCheckout />
}
